import React from "react";
import {Button, Input} from "reactstrap";
import * as yup from "yup";
import {IErrorClassifierErrorKeyForm} from "../../../../store/errorClassifier/types";
import {useFormik} from "formik";
import {useCreateErrorKey} from "./hooks/useCreateErrorKey";

interface ErrorKeyItemCreateProps {
    isRemoveMode?: boolean;
}

const ErrorKeyItemCreate: React.FC<ErrorKeyItemCreateProps> = ({isRemoveMode}) => {
    const {mutate: createErrorKey} = useCreateErrorKey();

    const handleSubmitForm = (values: IErrorClassifierErrorKeyForm) => {
        if (isRemoveMode) return

        createErrorKey(values);
        resetForm();
    }

    const validationSchema: yup.Schema<IErrorClassifierErrorKeyForm> = yup.object().shape({
        name: yup.string()
            .min(1, "min 1 character")
            .max(75, "max 50 characters")
            .required("Key is required"),
    });

    const initialValues: IErrorClassifierErrorKeyForm = {
        name: "",
    }

    const {
        values,
        handleSubmit,
        handleChange,
        resetForm,
        isValid
    } = useFormik({
        initialValues: initialValues,
        onSubmit: handleSubmitForm,
        validationSchema: validationSchema,
        validateOnBlur: true,
        validateOnChange: true,
        validateOnMount: true,
        enableReinitialize: true
    });

    return (
        <form onSubmit={handleSubmit}>
            <div className="d-flex align-items-center justify-content-start gap-1">
                <Input id="name" name="name" value={values.name} onChange={handleChange} placeholder="Add Key"
                       disabled={isRemoveMode}/>
                <Button type="submit" color="success" disabled={!isValid || isRemoveMode}>Add</Button>
            </div>
        </form>
    )
}

export default ErrorKeyItemCreate;